import { render, staticRenderFns } from "./tplSearch.vue?vue&type=template&id=0f65d81c"
import script from "./tplSearch.vue?vue&type=script&lang=js"
export * from "./tplSearch.vue?vue&type=script&lang=js"
import style0 from "./tplSearch.vue?vue&type=style&index=0&id=0f65d81c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./tplSearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports